import * as React from 'react';
import {
  TextFormatType,
  TranslationFormatType
} from '../../../models/chatChannelModel/message/format';
import {styled} from '../../../utils';
import Clearfix from '../../Clearfix';
import {ChatBubbleProps} from './types';

interface MainProps {
  fromCurrentUser: boolean;
}

const Main = styled('p')<MainProps>(
  ({theme}) => ({
    fontFamily: theme.fontFamily.base,
    fontSize: 16,
    background: '#F1F3F6',
    color: '#1B202A',
    float: 'left',
    display: 'block',
    borderRadius: 12,
    padding: '17px 12px',
    boxSizing: 'border-box',
    margin: '2px 0',
    maxWidth: 425,
    width: '-webkit-fit-content'
  }),
  ({fromCurrentUser, theme}) => {
    if (fromCurrentUser) {
      return {
        background: theme.color.primary,
        color: '#fff',
        float: 'right'
      };
    }
    return {};
  }
);

export default class ChatBubble extends React.Component<ChatBubbleProps, {}> {
  public render() {
    const {
      message: {format},
      fromCurrentUser,
      mainClassName,
      ...restProps
    } = this.props;

    return (
      <Clearfix {...restProps}>
        <Main fromCurrentUser={fromCurrentUser} className={mainClassName}>
          {(format as TextFormatType).text && (format as TextFormatType).text}
          {(format as TranslationFormatType).translation &&
            (format as TranslationFormatType).translation.text}
        </Main>
      </Clearfix>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatBubble/ChatBubble.tsx